// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hmAggTw_52jl8Y {
  display: flex;
  position: relative;
  z-index: 10;
  flex-direction: row;
  align-items: center;
  width: calc(100% - 8px * 2);
  height: 8px;
  padding: var(--ds-space-0, 0) 8px;
  transition: opacity;
  opacity: 0;
  cursor: pointer;
  will-change: clip-path;
  gap: var(--ds-space-050, 3px);
}
.hmAggTw_52jl8Y.K2Xd_NTGA1OoxZ {
  pointer-events: none;
}
.hmAggTw_52jl8Y:hover {
  transition-delay: 0.15s;
  opacity: 1;
}
.hmAggTw_52jl8Y .wwH06nzO7Ortph {
  flex: 50%;
  width: 100%;
  height: 0;
  border-top: 2px dashed var(--ds-background-accent-gray-subtle-hovered, #b3b9c4);
}
.hmAggTw_52jl8Y .gTTvuOpO2bfrIf {
  position: relative;
  flex: 0 0 auto;
  width: 22px;
  height: 18px;
  border-radius: var(--ds-border-radius-100, 4px);
  background-color: var(--ds-surface, #ffffff);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
}
.hmAggTw_52jl8Y .gTTvuOpO2bfrIf::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 1.5px;
  height: 10px;
  transform: translate(-50%, -50%);
  border-radius: 1px;
  background-color: var(--ds-text-subtle, #44546f);
}
.hmAggTw_52jl8Y .gTTvuOpO2bfrIf::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 1.5px;
  transform: translate(-50%, -50%);
  background-color: var(--ds-text-subtle, #44546f);
}
`, ""]);
// Exports
export var listCardGap = `hmAggTw_52jl8Y`;
export var disabled = `K2Xd_NTGA1OoxZ`;
export var hoverBar = `wwH06nzO7Ortph`;
export var hoverIcon = `gTTvuOpO2bfrIf`;
export default ___CSS_LOADER_EXPORT___;
